import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagFailToCreateVsa: {
		id: 'servicedesk-settings-virtual-agent-landing.services.create-virtual-agent.error-flag-fail-to-create-vsa',
		defaultMessage: "We couldn't create your virtual service agent",
		description: 'Title of error flag shown when virtual service agent creation fails',
	},
	errorFlagFailToCreateVa: {
		id: 'servicedesk-settings-virtual-agent-landing.services.create-virtual-agent.error-flag-fail-to-create-va',
		defaultMessage: "We couldn't create your virtual agent",
		description: 'Title of error flag shown when virtual agent creation fails',
	},
	errorFlagCtaRefreshAndTryAgain: {
		id: 'servicedesk-settings-virtual-agent-landing.services.create-virtual-agent.error-flag-cta-refresh-and-try-again',
		defaultMessage: 'Refresh the page and try again',
		description: 'Message shown in error flag when virtual service agent creation fails',
	},
});
